
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Notificacoes",
  computed: {
    ...mapGetters("alertas", ["MENSAGENS"]),
  },
  methods: {
    ...mapMutations("alertas", ["PUSH_MENSAGENS", "REMOVE_MENSAGEM","LIMPAR_TODAS_MENSAGENS"]),

  },

  filters: {
    date(val) {
      return new Date(val).toLocaleString();
    },
  },
};
